import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  actorNames?: string[];
}

export default function MovieCard({ movie, actorNames = [] }: MovieCardProps) {
  return (
    <Link
      to={`/movies/detail/${movie.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all hover:border-primary-300"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title}海报`}
          title={`${movie.title}电影海报`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-primary-500/95 px-2 py-1 text-[11px] font-medium text-background-50">
          {movie.year}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-foreground-950/70 px-2 py-1 text-[11px] font-medium text-background-50">
          <i className="ri-star-fill text-accent-400"></i>
          {movie.rating.toFixed(1)}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
          {movie.title}
        </h3>
        <div className="mt-2 flex flex-wrap gap-1.5">
          {movie.genres.map((g) => (
            <span
              key={g}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-900"
            >
              {g}
            </span>
          ))}
        </div>
        {actorNames.length > 0 && (
          <p className="mt-2.5 line-clamp-1 text-xs text-foreground-500">
            <i className="ri-user-star-line mr-1"></i>
            主演：{actorNames.join(' / ')}
          </p>
        )}
        <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">
          {movie.excerpt}
        </p>
        <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-primary-600">
          查看详情
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
        </span>
      </div>
    </Link>
  );
}